export default {

	async page_list (params) {

		const search = new Anvil.models.Record({
			machine_id: params.machine_id || null
		})

		const [ error_log, terminals ] = await Promise.all([
			Anvil.models.c_order.ErrorLogList.fetch(search.machine_id),
			Anvil.models.c_order.TerminalList.fetch()
		])

		await Anvil.renderPage('/c_order/error_log/page_list', { error_log, terminals, search })
	},

	async action_refresh () {

        const [ error_log, terminals ] = await Promise.all([
			Anvil.models.c_order.ErrorLogList.fetch(Anvil.page.search.machine_id),
			Anvil.models.c_order.TerminalList.fetch()
		])

		Anvil.page.error_log = error_log
		Anvil.page.terminals = terminals
		Anvil.models.components.Grid.find('#error_log_grid').list = error_log
	},

	async modal_details (log_entry_id) {

		const log_entry = await Anvil.models.c_order.ErrorLogEntry.fetch(log_entry_id)
		await Anvil.modal('/c_order/error_log/modal_details', { log_entry })
	},

	async page_ntak_error_list ({db_name}) {

		const error_log = await Anvil.models.c_order.NtakErrorLogList.fetch(db_name)
		await Anvil.renderPage('/c_order/error_log/page_ntak_error_list', { db_name, error_log })
	},

	async action_refresh_ntak_error_list (db_name) {

		const error_log = await Anvil.models.c_order.NtakErrorLogList.fetch(db_name)

		Anvil.page.error_log = error_log
		Anvil.models.components.Grid.find('#error_log_grid').list = error_log
	},

	async modal_ntak_error_details (db_name, receipt_uuid) {

		const { receipt, order_report } = await Anvil.REST.get(`/c_order/terminal/fetch_ntak_errors/${db_name}/${receipt_uuid}`)

		receipt.payment = JSON.parse(receipt.payment)
		receipt.customer = JSON.parse(receipt.customer)
		receipt.state_message = JSON.parse(receipt.state_message)

		await Anvil.modal('/c_order/error_log/modal_ntak_error_details', { db_name, receipt, order_report })
	},

	async action_resend_ntak_order_summary (db_name, receipt_uuid) {

		const res = await Anvil.REST.get(`/c_order/terminal/resend_ntak_order_summary/${db_name}/${receipt_uuid}`)
		if (!res.success) {
			Anvil.toast.warning('Sikertelen művelet', 'Nem sikerült a rendelést újraküldeni az NTAK-nak<br />Részletek: ' + res.error)
			return
		}

		if (Anvil.modal_open) {
			Anvil.page.modal.close()
		}
		Anvil.toast.success('Sikeres művelet', 'A rendelés újraküldése az NTAK-nak sikeresen ütemezve lett')

		await this.action_refresh_ntak_error_list(Anvil.page.db_name)
	},

	async action_manual_fix_ntak_order_summary (db_name, receipt_uuid) {

		const res = await Anvil.REST.get(`/c_order/terminal/manual_fix_ntak_order_summary/${db_name}/${receipt_uuid}`)
		if (!res.success) {
			Anvil.toast.warning('Sikertelen művelet', 'Nem sikerült a rendelés javításának bejegyzése<br />Részletek: ' + res.error)
			return
		}

		if (Anvil.modal_open) {
			Anvil.page.modal.close()
		}
		Anvil.toast.success('Sikeres művelet', 'A rendelés kézi javítása bejegyzésre került')

		await this.action_refresh_ntak_error_list(Anvil.page.db_name)
	}
}